import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locale.en';
import fr from './locale.fr';
import nl from './locale.nl';
import pl from './locale.pl';

Vue.use(VueI18n);

const DEFAULT_CURRENCY = {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
};

const numberFormats = {
  en: { currency: DEFAULT_CURRENCY },
  fr: { currency: DEFAULT_CURRENCY },
  nl: { currency: DEFAULT_CURRENCY },
};

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    ...en,
    ...fr,
    ...nl,
    ...pl,
  },
  numberFormats,
});

// custom pluralization rules, see https://kazupon.github.io/vue-i18n/guide/pluralization.html#custom-pluralization
const defaultGetChoiceIndex = i18n.getChoiceIndex;
i18n.getChoiceIndex = function getChoiceIndex(choice, choicesLength) {
  // choicesLength is 4
  // this is reserved for notifications, combination of a single/multiple notifier(s) + single/multiple notifiable(s)
  // choice 0: single notifier, single notifiable
  // choice 1: single notifier, multiple notifiables
  // choice 2: multiple notifiers, single notifiable
  // choice 3: multiple notifiers, multiple notifiables
  if (choicesLength === 4) return choice;
  // choicesLength is 3: return default function
  return defaultGetChoiceIndex(choice, choicesLength);
};

// commented this out due to pending Vite migration (uncomment temporarily if needed for local dev)
// if (module.hot) {
//   /* eslint-disable */
//   // WARNING: this MUST be statically defined (each language separately, to ensure "hot reload" remains working)
//   module.hot.accept([
//     './locale.en',
//     './locale.fr',
//     './locale.nl',
//     './locale.pl',
//   ], () => {
//     i18n.setLocaleMessage('en', en);
//     i18n.setLocaleMessage('fr', fr);
//     i18n.setLocaleMessage('nl', nl);
//     i18n.setLocaleMessage('pl', pl);
//   });
//   /* eslint-enable */
// }

export default i18n;
